import {
    doc,
    setDoc,
    updateDoc,
    getDoc,
    onSnapshot,
    deleteDoc,
    getFirestore
} from "firebase/firestore"
import { v4 as uuidv4 } from "uuid"

import app from "./config"

const db = getFirestore(app)

export const subscribe = (nameCol, idDoc, cb) => {
    const docRef = doc(db, nameCol, idDoc)

    onSnapshot(
        docRef,
        (data) => {
            cb(data.data())
        },
        (err) => {
            console.log(err)
        }
    )
}

export const addDocument = async(nameCol, data, idDoc) => {
    const tempId = idDoc || uuidv4()

    const docRef = doc(db, nameCol, tempId)
    await setDoc(docRef, data)
}

export const getDocument = async(nameCol, idDoc) => {
    const docRef = doc(db, nameCol, idDoc)
    const docSnap = await getDoc(docRef)

    if (docSnap.exists()){
        return docSnap.data()
    }

    return null
}

export const updateDocument = async(nameCol, idDoc, data) => {
    const docRef = doc(db, nameCol, idDoc)
    await updateDoc(docRef, data)
}

export const deleteDocument = async(nameCol, idDoc) => {
    const docRef = doc(db, nameCol, idDoc)
    await deleteDoc(docRef)
}
